import GameCommonDis from "../Description/GameCommonDis";
import { useEffect, useRef } from "react";

export default function CommenDis(props) {
  const video = useRef(null);
  var videoURL = "";

  function tags_list(value) {
    var tags_list = [];
    var i;
    for (i = 0; i < value.length; i++) {
      tags_list[i] = (
        <span key={i} className="tags">
          {value[i]}
        </span>
      );
    }
    return tags_list;
  }

  function setvideo(value) {
    var videoLink = value;
    if (videoLink.length > 30) {
      video.current.setAttribute("style", "display:flex");
      
    } else {
      // video.current.setAttribute("style", "display:none !important");
     
    }
  }

  useEffect(() => {
    setvideo(props.video);
  }, );

  return (
    <div>
      <div className="dis-container">
        <div className="thumb-dis">
          <div className="dis">
            
            <div className="contant para description"dangerouslySetInnerHTML={{__html:props.dis}}></div>
            {props.howto!=undefined&&<h2 className="contant name">How to play {props.name} Game</h2>}
            <div className="contant para description"dangerouslySetInnerHTML={{__html:props.howto}}></div>
            <div className="contant tags-list">{tags_list(props.tag)}</div>
          </div>

          {props.video.length > 30 &&<div ref={video} className="videos">
              <h2 className="contant name">Walkthrough</h2>
              <iframe
                className="videos_iframe"
                width="560"
                height="315"
                src={props.video+"?rel=0"}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen="allowfullscreen"
              ></iframe>
            </div>}
            
          
        </div>
      </div>
      {/* <GameCommonDis /> */}
    </div>
  );
}
